import { Popover } from 'antd';
import { convertToArray, getLinkRow } from 'mixins/helpers';
import React, { FC, ReactElement } from 'react';
import ArrowIcon from './arrow.svg';
import { IServiceItemProps } from './type';

import './index.scss';

const ServiceGovItem: FC<IServiceItemProps> = (props: IServiceItemProps) => {
    const getLinks = (links: any[]): ReactElement => {
        let node = null;

        links.forEach((x) => {
            node = getLinkRow(x.title, x.link, node);
        });

        return node;
    };

    return (
        <Popover
            placement="bottomRight"
            content={getLinks(convertToArray(props.links))}
        >
            <div className="service-link">
                <div className="service-link__name">{props.name}</div>

                <div>
                    <ArrowIcon
                        style={{
                            display: 'block',
                        }}
                    />
                </div>
            </div>
        </Popover>
    );
};

export default ServiceGovItem;
